import { render } from "./UserAvatar.vue?vue&type=template&id=5608a152&scoped=true"
import script from "./UserAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAvatar.vue?vue&type=script&setup=true&lang=js"

import "./UserAvatar.vue?vue&type=style&index=0&id=5608a152&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5608a152"],['__file',"src/core/layout/UserAvatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5608a152"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5608a152', __exports__)) {
    console.log('reload')
    api.reload('5608a152', __exports__)
  }
  
  module.hot.accept("./UserAvatar.vue?vue&type=template&id=5608a152&scoped=true", () => {
    console.log('re-render')
    api.rerender('5608a152', render)
  })

}


export default __exports__